import { Component, OnInit, Input } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';
import { SnackBarService } from '../../services/snack-bar.service';

import { List } from '../../models/list';
import { Recipe } from '../../models/recipe';

@Component({
  selector    : 'manage-list-recipe',
  templateUrl : 'manage-list-recipe.html',
  styleUrls   : [ 'manage-list-recipe.scss' ]
})

export class ManageListRecipeComponent implements OnInit {
  @Input() item   : List | Recipe;
  @Input() isList : boolean;

  itemName          : string;
  titleCaseItemName : string;
  editing           : boolean = false;
  name              : string = '';

  constructor(
    public firebaseService  : FirebaseService,
    private snackBarService : SnackBarService
  ) {}

  ngOnInit() : void {
    this.itemName          = this.isList ? 'list' : 'recipe';
    this.titleCaseItemName = this.isList ? 'List' : 'Recipe';
  }

  edit() : void {
    this.editing = true;
    this.name = this.item.name;
  }

  cancelEditing(): void {
    this.editing = false;
  }

  save() : void {
    const name : string = this.name.trim(),
      newName : boolean = name !== this.item.name;

    if (!(name.length && newName))
      return this.cancelEditing();

    this.firebaseService.updateListRecipe(this.isList, this.item, { name : name })
      .then(() => this.cancelEditing());
  }

  delete() : void {
    this.firebaseService.updateListRecipe(this.isList, this.item, { deadManWalking : true });

    this.snackBarService.show({
      message         : `You deleted ${ this.itemName }`,
      emphasisMessage : this.item.name,
      action          : 'UNDO'
    })
    .then(undo => {
      if (undo) {
        this.cancelEditing()

        this.firebaseService.updateListRecipe(this.isList, this.item, { deadManWalking : false });
      } else {
        this.firebaseService.removeListRecipe(this.isList, this.item);
      }
    });
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/manage-list-recipe/manage-list-recipe.ts